"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformStringToOnlyNumbersString = void 0;
const transformStringToOnlyNumbersString = (stringToTransform) => stringToTransform.replace(/[^\d]+/g, "");
exports.transformStringToOnlyNumbersString = transformStringToOnlyNumbersString;
//# sourceMappingURL=transformStringToOnlyNumbersString.js.map